import type { RicosNodeExtension } from './../../ricos-types';

export const createRicosNodeExtension = <Options = unknown, Storage = unknown>(
  extension: RicosNodeExtension<Options, Storage>
): RicosNodeExtension<Options, Storage> => extension;
